// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"9836ed43","44":"1de6eef7","453":"77993765","486":"d97c6547","764":"ac6555e5","885":"f1ed2ed1","919":"63d2cc1a","941":"451e99b4"}[chunkId] + ".chunk.js";
};